import * as React from 'react';
import card from '../../images/karta-mm.png'
import Account from "./Account";
import {getCurrentUser} from "../../utilities/Utilities";
import Services from "../../utilities/Services";
import {AplikacjeMobilne} from "../sharedComponents/AplikacjeMobilne";

interface Props {
}

export class Card extends React.Component<any> {

    state = {
        user: [],
        karty: [],
        upust: '',
        upustObrot: '',
        rabatKwota: '',
        loading: false
    }

    componentDidMount() {
        this.pobierzKlient();
        this.setState({
            upust: getCurrentUser().upust,
            upustObrot: getCurrentUser().upustObrot,
            rabatKwota: getCurrentUser().rabatKwota
        });

        //alert(this.state.klient)
    }

    pobierzKlient = () => {
        this.setState({loading: true});
        //alert(axios.defaults.headers.common.Authorization)

        Services.getKlient(getCurrentUser().klientId)
            .then((response) => {

                this.setState({user: response.data})

                Services.getKlientKarty()
                    .then((response2) => {

                        this.setState({karty: response2.data, loading: false})

                    }).catch((error) => {
                    this.setState({loading: false});
                    console.log('get Klient error');
                })

            }).catch((error) => {
            this.setState({loading: false});
            console.log('get Klient error');
        })

    }

    render() {
        let {upust,upustObrot,rabatKwota,user, loading, karty} = this.state;
        return <section id={'card'}>
            <h3>Karta</h3>
            {
                (loading)?
                    <h5>Ładowanie...</h5>
                        :
                //@ts-ignore
                (karty?.karty?.length > 0)?
                    <>
                        <img src={card} className={'card-img'}/>
                        {/*//@ts-ignore*/}
                        <div><b>{(user.kontrahentFaktura)? user?.kontrahentFaktura : null}</b></div>
                        {/*//@ts-ignore*/}
                        {(karty?.upust) &&
                        <div>
                            {/*//@ts-ignore*/}
                            <div>Ostatnio udzielony upust do obrotu: <span>{(karty?.upust ? karty?.upust?.upustObrot + ' %' : 0 + ' %')}</span></div>
                            {/*//@ts-ignore*/}
                            <div>Obrót rok obecny: <span>{(karty?.upust?.obrot ? karty?.upust?.obrot + ' ' + karty?.upust?.rabatWaluta : 0 + ' ' + karty?.upust?.rabatWaluta)}</span></div>
                            {/*//@ts-ignore*/}
                            <div>Wartość rabatu kwotowego: <span>{(karty?.upust?.rabatKwota ? karty?.upust?.rabatKwota + ' ' + karty?.upust?.rabatWaluta : 0 + ' ' + karty?.upust?.rabatWaluta)}</span></div>
                        </div>
                        }

                        {/*{(upust)? <div>Upust stały: <span>{upust}%</span></div> : null}*/}
                        {/*/!*<div>Upust stały: <span>{(upust)? {upust}+'%' : ''}</span></div>*!/*/}
                        {/*{(upustObrot)? <div>Ostatni udzielony upust od obrotu: <span>{upustObrot}%</span></div> : null}*/}
                        {/*/!*<div>Ostatni udzielony upust od obrotu: <span>{upustObrot}%</span></div>*!/*/}
                        {/*{(rabatKwota)? <div>Kwota rabatu na następny zakup: <span>{rabatKwota} PLN</span></div> : null}*/}
                        {/*/!*<div>Kwota rabatu na następny zakup: <span>{rabatKwota} PLN</span></div>*!/*/}
                    </>
                    :
                    <>
                        <h5>Brak aktywnej karty</h5>
                        <p>Aby aktywować kartę, należy pobrać aplikacje na telefon i przejść do zakładki "Karta".</p>
                        <AplikacjeMobilne wersjaPelna={false}/>
                    </>
            }

        </section>
    }

}

export default Card;

